import { render, staticRenderFns } from "./TaskToQaModal.vue?vue&type=template&id=e37509ce&scoped=true"
import script from "./TaskToQaModal.vue?vue&type=script&lang=js"
export * from "./TaskToQaModal.vue?vue&type=script&lang=js"
import style0 from "./TaskToQaModal.vue?vue&type=style&index=0&id=e37509ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37509ce",
  null
  
)

export default component.exports